import { Injectable } from "@angular/core";
import { ExploreService } from "@spotter/services/sightings/explore-service";
import { FilterService } from "@spotter/services/sightings/filter-service";
import { AuthService } from "@spotter/services/user/auth-service";

@Injectable({
    providedIn: 'root'
})
export class UserInisitaliser {

    callbackFunction?: Function;

    constructor(public auth: AuthService) { }

    initialise(callbackFunction?: Function): Promise<boolean> {
        this.callbackFunction = callbackFunction;

        return new Promise(resolve => {
            this.auth.loadUserFromStorage().then(() => {
                if (this.callbackFunction)
                    this.callbackFunction();
                resolve(true);
            });
        });
    }
}